import React, { useContext } from "react";
import Modal from "../../components/Modal";
import { ModelCxContext } from "../../context/modelCx.context";
import TextArea from "../../components/TextArea";
import { locationInfoText } from "../../utility/locationInfoText";

function LocationMetaModal({ currentLocation, setOpenLocationMetaModal }) {
  const { officeMetaDataForLocation, awsgwOfficeMetaDataResult } = useContext(ModelCxContext);
  // #657: only notes that belong to THIS location — the live lookup first, the shared
  // value as a fallback (it can be wiped, or still hold the previous office).
  const scheduleInfo = locationInfoText(currentLocation, officeMetaDataForLocation, awsgwOfficeMetaDataResult);

  // - - - - - - - - - -

  const onClose = () => {
    setOpenLocationMetaModal({ show: false });
  };

  // - - - - - - - - - -

  return (
    <Modal onClose={() => onClose()}>
      <Modal.Header>
        <div className="flex justify-between">
          <div>Location Information</div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-4 w-[400px]">
          <div className="text-lg font-bold">{currentLocation}</div>
          <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
            <div>
              <TextArea
                readOnly={true}
                placeholder="Custom Notes"
                rows={20}
                value={scheduleInfo}
                className="bg-skin-base border border-black/20 "
              ></TextArea>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
}

export default LocationMetaModal;
